import { connect } from "react-redux";

import { selectPagesCount, selectIsDrm } from "~/store/ducks/domain/config";
import { selectIsMaterialLayerEnabled } from "~/store/ducks/domain/ui/materialLayer";
import {
  selectAbsolutePage,
  selectIsAnnotationsVisible
} from "~/store/ducks/user/uistate";

import PageView from "./PageView";

function mapStateToProps(state) {
  return {
    absolutePage: selectAbsolutePage(state),
    pagesCount: selectPagesCount(state),
    isMaterialVisible: selectIsMaterialLayerEnabled(state),
    isAnnotationsVisible: selectIsAnnotationsVisible(state),
    isDrm: selectIsDrm(state)
  };
}

export default connect(mapStateToProps)(PageView);
